module.exports = __webpack_public_path__ + "static/media/oil-change-white.d80ad736.svg";